import { useCommonServices } from '../../../../lib/hooks'
import { type BrowserService } from '../../../../lib/services/browser'

export enum GoInstallType {
  Chrome = 'chrome',
  Edge = 'edge',
}

function isEligibleForInstall(install: GoInstallType, browserService: BrowserService): boolean {
  return installEligibilityMap[install](browserService)
}

const installEligibilityMap: Record<GoInstallType, (browserService: BrowserService) => boolean> = {
  [GoInstallType.Chrome]: bs => bs.isChrome && !bs.isMobileAndroidOrIOS,
  [GoInstallType.Edge]: bs => bs.isEdgeChromium && !bs.isMobileAndroidOrIOS,
}

export function firstEligibleInstall(): GoInstallType | undefined {
  const { browserService } = useCommonServices()

  for (const install of [GoInstallType.Chrome, GoInstallType.Edge]) {
    if (isEligibleForInstall(install, browserService)) {
      return install
    }
  }

  return undefined
}
